import React, { useEffect } from 'react';
import { useParams, useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useMainStore } from '../stores/mainStore';
import { Badge, Box, Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Trans } from './Trans';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

export const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    backgroundColor: 'transparent',
    background: 'linear-gradient(to top, #fde047, #f97316)',
    color: 'white',
    fontSize: '1.2rem',
    height: '80px',
    minWidth: '80px',
    padding: '0',
    transform: 'translate(50%, 50%)',
    clipPath:
      'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', // Star shape
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const Profile: React.FC = () => {
  const { id, lang } = useParams<{ id: string; lang: string }>();
  const setActiveCharacter = useMainStore((state) => state.setActiveCharacter);
  const getCharacterPosts = useMainStore((state) => state.getCharacterPosts);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        await setActiveCharacter(id);
        await getCharacterPosts(id);
      }
    };
    fetchData();
  }, [id]);

  return (
    <div className="app-container1 overflow-y-auto">
      <div className={`flex flex-col ${id === 'me' ? 'mb-12' : ''}`}>
        {id === 'me' ? (
          <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
              <Tabs
                centered
                variant="fullWidth"
                value={location.pathname.includes('prices') ? 1 : 0}
              >
                <Tab
                  icon={<AccountCircleIcon />}
                  label={<Trans>Account</Trans>}
                  onClick={() =>
                    navigate(`${lang ? `/${lang}` : ''}/app/profile/me`)
                  }
                />
                <Tab
                  icon={<WorkspacePremiumIcon />}
                  label={<Trans>Subscription Tiers</Trans>}
                  onClick={() =>
                    navigate(`${lang ? `/${lang}` : ''}/app/profile/me/prices`)
                  }
                />
              </Tabs>
            </Box>
            <Outlet />
          </>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};
